import React, { useState, useEffect } from "react";
import '../css/agenda.css';
import Botolan from "../components/botolan";

export default function Agenda() {
    const [showComedy, setShowComedy] = useState(true);

    useEffect(() => {
        const interval = setInterval(() => {
            setShowComedy(prevState => !prevState);
        }, 2000);

        return () => clearInterval(interval);
    }, []);
    return (
        <section className="agenda">
            <p>Agenda SMA Lab UM</p>
            <div className="k-bawah d-lg-flex d-md-flex justify-content-between mt-5">
                <div className="d-flex  flex-column justify-content-between align-items-start">
                    <h1 className="acara">Berbagai acara sekolah di SMA Lab UM</h1>
                    <bottom className="bawah lain  btn d-flex align-items-center gap-3 cursor-pointer">
                        <p className="lain my-auto">Agenda Lainnya</p>
                        <img src="../../assets/agenda/arrow-orange-right.svg" alt="Arrow" />
                    </bottom>
                </div>
                <div className="acara-kanan">
                    <div className="text2">
                        <ul className={`comedy ${showComedy ? 'animate__animated animate__fadeInUp' : 'animate__animated animate__fadeOutDown'}`}>
                            Standup Comedy Routine : BOTOLAN
                        </ul>
                        <ul className={`festival ${showComedy ? 'animate__animated animate__fadeOutDown' : 'animate__animated animate__fadeInUp'}`}>
                            Festival Pemilu: Kepoin Parpol, Adu <br /> Ide, Main Bareng
                        </ul>
                    </div>

                    <ul className="feb" style={{ fontWeight: "lighter" }}>
                        20 Februari • 09:00 WIB
                    </ul>
                    <div className="b-aula d-flex align-items-center gap-2 justify-content-end">
                        <img src="../../assets/agenda/location.svg" alt="Location Icon" className="lokasi" />
                        <p className="aula">Aula Sekolah</p>
                    </div>
                    <div className="botolan">
                        <Botolan />
                    </div>
                </div>
            </div>
        </section>
    )
}